import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Zoom } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import { forwardRef, FunctionComponent, PropsWithChildren, ReactElement, ReactNode, Ref, useState } from 'react';
import { useDialogAnimation } from '../../util/Animation';
import { muiStyleSheet } from '../../util/Styles';

type Props = PropsWithChildren<{
	title: string;
	open: boolean;
	submit: () => Promise<unknown>;
	onClose: () => unknown;
	extraAction?: ReactNode;
}>;

type DialogTransitionProps = TransitionProps & {
	children: ReactElement;
};

export const FormDialog: FunctionComponent<Props> = (props) => {
	const [saving, setSaving] = useState(false);
	const { animationsDisabled, dialogProps } = useDialogAnimation();

	async function submit() {
		try {
			setSaving(true);
			await props.submit();
		} finally {
			setSaving(false);
		}
	}
	return <Dialog open={props.open} onClose={props.onClose} maxWidth="sm"
		{...dialogProps}
		{...(!animationsDisabled && {
			slots: {
				transition: Transition,
			},
		})}
	>
		<DialogTitle>{props.title}</DialogTitle>
		<Box sx={styles.topRightAction}>{props.extraAction}</Box>
		<DialogContent>
			{props.children}
		</DialogContent>
		<DialogActions>
			<Button onClick={props.onClose}>Cancel</Button>
			<Button onClick={submit} variant="contained" disabled={saving}>
				{saving ? 'Saving...' : 'Save'}
			</Button>
		</DialogActions>
	</Dialog>;
};

const Transition = forwardRef(function Transition(
	props: DialogTransitionProps,
	ref: Ref<unknown>,
) {
	return <Zoom ref={ref} {...props} />;
});

const styles = muiStyleSheet({
	topRightAction: {
		position: 'absolute',
		right: 8,
		top: 16,
	},
});